import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const acknowledgeBuyLabelErrors = {
  name: "acknowledgeBuyLabelErrors" as const,
  input: z.object({ fulfillmentGroupIds: z.array(zExt.objectId()) }),
  output: z.object({ success: z.boolean() }),
};
